/* eslint-disable @typescript-eslint/no-explicit-any */
import { TRANSFER_MODE, type TransferConfiguration } from '@/types/transfer.type';

export const mapTransferConfiguration = (data: Record<string, any>): TransferConfiguration => ({
  agent_id: data.agent_id,
  prompt: data.prompt ?? '',
  transfer_mode: data.transfer_mode ?? TRANSFER_MODE.STATIC,
  enabled: data.enabled ?? false,
  max_attempts: data.max_attempts ?? null,
});

export const mapTransferConfigurationResponse = (
  response: Record<string, any>
): TransferConfiguration => mapTransferConfiguration(response.data);
